import Input from "../../atoms/Input/Input";
import { useFormContext } from "react-hook-form";
import FileInput from "../../atoms/FileInput/FileInput";

const LogoSection = () => {
  const {
    formState: { errors },
    register,
    control,
    getValues,
  } = useFormContext();

  return (
    <div className="flex-column gap-20">
      <Input
        type="text"
        placeholder="Title"
        label="Title*"
        register={register}
        registerName="logoTitle"
        errorMessage={errors?.logoTitle?.message}
      />
      <FileInput
        label="Logo*"
        register={register}
        registerName="logoImage"
        disabled={false}
        accept="image/png,image/jpeg,image/jpg,image/svg+xml"
        control={control}
        errorMessage={errors?.logoImage?.message}
        value={getValues("logoImage") ?? ""}
      />
    </div>
  );
};

export default LogoSection;
